const subscriptions = {};
const lastPayloads = {};
const getNextUniqueId = getIdGenerator();

export function subscribe(eventType, callback) {
    const id = getNextUniqueId();

    if (!subscriptions[eventType]) subscriptions[eventType] = {};

    subscriptions[eventType][id] = callback;

    if (Object.prototype.hasOwnProperty.call(lastPayloads, eventType)) {
        callback(lastPayloads[eventType]);
    }

    return () => {
        delete subscriptions[eventType][id];
        if (Object.keys(subscriptions[eventType]).length === 0) delete subscriptions[eventType];
    };
}

export function publish(eventType, arg) {
    // Only payload publishes are sticky. Fire-and-forget events (e.g. *_REFRESH with
    // no argument) must clear any previous payload — otherwise re-subscribing after a
    // callback identity change (common when isLoading toggles) replays the refresh and
    // loops the list loader forever.
    if (arguments.length > 1) {
        lastPayloads[eventType] = arg;
    } else {
        delete lastPayloads[eventType];
    }

    if (!subscriptions[eventType]) return;

    Object.keys(subscriptions[eventType]).forEach((key) => subscriptions[eventType][key](arg));
}

function getIdGenerator() {
    let lastId = 0;
    return function getNextUniqueId() {
        lastId += 1;
        return lastId;
    };
}
